import {
  createFrontendModule,
  PageLayout,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { AppPageLayout } from '../components/page-layout/AppPageLayout';

/**
 * Replaces the default page layout of `@backstage/plugin-app`
 * (`component:app/core-page-layout`) with the Xelerate one, see
 * `AppPageLayout`.
 */
const pageLayout = SwappableComponentBlueprint.make({
  name: 'core-page-layout',
  params: define =>
    define({
      component: PageLayout,
      loader: () => AppPageLayout,
    }),
});

export const pageLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [pageLayout],
});
